<template>
    <section
        class="lg:min-h-[700px] relative overflow-hidden"
        :style="{ backgroundImage: `url(${$asset('/hkcm/images/bg_whatYouGet.png', 'public')})`, backgroundSize: 'cover', backgroundPosition: 'center' }"
    >
        <div class="grid grid-cols-1 lg:grid-cols-2 min-h-[700px]">
            <!-- Left Column: Text Content -->
            <div class="py-16 pl-6 lg:pl-16 pr-6 lg:pr-8 m-auto block lg:flex items-center">
                <div class="lg:container">
                    <!-- Headline -->
                    <h2 class="text-[28px] md:text-4xl lg:text-[44px] lg:leading-[57px] font-semibold leading-tight" :style="{ color: titleColor }">
                        <span v-html="renderTitle()"></span>
                    </h2>

                    <!-- Description -->
                    <p class="text-[18px] leading-tight lg:leading-relaxed mt-8 font-pro" :style="{ color: descriptionColor }" v-html="description"></p>

                    <!-- CTA Button -->
                    <router-link v-if="showCta && ctaLink" :to="ctaLink" :class="ctaStyle">
                        {{ ctaText }}
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                        </svg>
                    </router-link>
                </div>
            </div>

            <!-- Right Column: Image -->
            <div class="relative h-full hidden lg:block">
                <img v-if="image" :src="image" :alt="imageAlt" class="absolute bottom-0 w-full mx-auto object-contain object-bottom h-[650px]" />
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        required: true
    },
    titleHighlight: {
        type: String,
        default: ''
    },
    titleHighlightColor: {
        type: String,
        default: '#2dd4bf'
    },
    titleHighlightGradientFrom: {
        type: String,
        default: ''
    },
    titleHighlightGradientTo: {
        type: String,
        default: ''
    },
    titleColor: {
        type: String,
        default: '#ffffff'
    },
    description: {
        type: String,
        default: ''
    },
    descriptionColor: {
        type: String,
        default: '#FFFFFF'
    },
    ctaText: {
        type: String,
        default: 'Mehr erfahren'
    },
    ctaLink: {
        type: String,
        default: ''
    },
    ctaStyle: {
        type: String,
        default: 'primary'
    },
    image: {
        type: String,
        default: ''
    },
    imageAlt: {
        type: String,
        default: 'Person'
    },
    showCta: {
        type: Boolean,
        default: true
    }
});

const renderTitle = () => {
    if (!props.titleHighlight) return props.title;

    const parts = props.title.split(props.titleHighlight);

    if (parts.length === 1) return props.title;

    const highlightStyle =
        props.titleHighlightGradientFrom && props.titleHighlightGradientTo
            ? `background: linear-gradient(to top, ${props.titleHighlightGradientFrom}, ${props.titleHighlightGradientTo}); -webkit-background-clip: text; -webkit-text-fill-color: transparent;`
            : `color: ${props.titleHighlightColor};`;

    return parts
        .map((part, index) => {
            if (index === 0) return part;

            return `<span style="${highlightStyle}">${props.titleHighlight}</span>${part}`;
        })
        .join('');
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
